module.exports = __webpack_public_path__ + "img/symbol_9.bf5ea072.png";